"use client";
import fetchAllCampuses from "@/app/cms/fetchAllCampuses";
import Campus from "@/app/types/Campus";
import {useEffect, useState} from "react";
import {useCampusContext} from "../contexts/CampusCookieContext";
import withSuspense from "../withSuspense";
import {sortBy} from "lodash";

const AdminCampusSwitcher: React.FC = () => {
	const {deleteCampus, setCampus, campus, isInitialized} = useCampusContext();
	const [allCampuses, setAllCampuses] = useState<Campus[]>([]);
	const [isClosed, setIsClosed] = useState(false);
	useEffect(() => {
		fetchAllCampuses().then((campuses) => {
			setAllCampuses(sortBy(campuses, "locationName"));
		});
	}, []);
	if (isClosed) {
		return null;
	}
	return (
		<div className="flex items-center gap-2 bg-white px-3 py-1">
			<div onClick={() => setIsClosed(true)} className="cursor-pointer px-2">
				X
			</div>
			<label htmlFor="campus-switcher">Switch Campus:</label>
			<select
				id="campus-switcher"
				className="rounded border-1 border-gray-900 px-2"
				value={campus?.campusId ?? "none"}
				onChange={(e) => {
					if (e.target.value === "none") {
						deleteCampus();
					} else {
						setCampus(e.target.value);
					}
				}}
			>
				<option value="none">
					{isInitialized && allCampuses.length ? "None" : "Loading…"}
				</option>
				{allCampuses.map(({campusId, locationName}) => (
					<option key={campusId} value={campusId}>
						{locationName}
					</option>
				))}
			</select>
		</div>
	);
};

export default withSuspense(AdminCampusSwitcher);
